/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {Tooltip} from 'react-tooltip'
import {toAbsoluteUrl} from '../../../helpers'
import {useLang, useSetLang, Lang} from '../../../i18n/Metronici18n'

type Props = {
  toggleBtnClass?: string
}

const languages: Record<Lang, {label: string; name: string; flag: string}> = {
  en: {label: 'EN', name: 'English', flag: toAbsoluteUrl('/media/flags/united-states.svg')},
  es: {label: 'ES', name: 'Español', flag: toAbsoluteUrl('/media/flags/mexico.svg')},
}

const LanguageToggle: FC<Props> = ({toggleBtnClass = ''}) => {
  const intl = useIntl()
  const lang = useLang()
  const setLanguage = useSetLang()

  const nextLang: Lang = lang === 'es' ? 'en' : 'es'
  // Se muestra el idioma al que se cambiará, no el actual
  const target = languages[nextLang]

  return (
    <>
      <a
        href='#'
        className={clsx('btn d-flex align-items-center px-2 fw-bold fs-7', toggleBtnClass)}
        data-tooltip-id='language-toggle-tooltip'
        data-tooltip-content={intl.formatMessage(
          {id: 'common.language.switchTo', defaultMessage: 'Switch to {language}'},
          {language: languages[nextLang].name}
        )}
        onClick={(e) => {
          e.preventDefault()
          setLanguage(nextLang)
        }}
      >
        <img className='w-15px h-15px rounded-1 me-2' src={target.flag} alt={target.name} />
        {target.label}
      </a>
      <Tooltip id='language-toggle-tooltip' place='bottom' />
    </>
  )
}

export {LanguageToggle}
